import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  MenuItem,
  CircularProgress ,
} from "@mui/material";
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { postData } from "../services/Request";


export default function AgentSignUp() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    address: "",
    category: "",
    companyName: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      name: form.name,
      email: form.email,
      password: form.password,
      type: form.category,
      company_name: form.companyName,
      address: form.address,
    };

    try {
      const res = await postData("api/auth/signup", payload);

      if (res.status === true) {
        toast.success(res.message || "Signup successful!");
        navigate("/Login");
        setLoading(false)
      }
      if (res.status === false){
        toast.error(res?.message || "Signup failed!");
        setLoading(false)
      }
    } catch (error) {
      console.error("Signup Error:", error);
      toast.error("Something went wrong! Please try again.");
      setLoading(false)
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        background: "linear-gradient(to right,rgb(229, 246, 220),rgb(202, 241, 158))",
        p: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          maxWidth: 500,
          width: "100%",
          borderRadius: "20px",
          borderTop: "6px solid #c6db8c",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          textAlign="center"
          mb={1}
          sx={{ color: "#94b145" }}
        >
          Agent Sign-Up
        </Typography>
        <Typography
          variant="body1"
          textAlign="center"
          mb={3}
          sx={{ color: "#555" }}
        >
          Become an agent for Safe Place – you can get checking immediately
          you’ve gone through our programme.
        </Typography>

        <form onSubmit={handleSubmit}>
          <TextField
            label="Full Name"
            name="name"
            fullWidth
            margin="normal"
            value={form.name}
            onChange={handleChange}
            required
          />
          <TextField
            label="Email"
            name="email"
            type="email"
            fullWidth
            margin="normal"
            value={form.email}
            onChange={handleChange}
            required
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            fullWidth
            margin="normal"
            value={form.password}
            onChange={handleChange}
            required
          />
          <TextField
            label="Address"
            name="address"
            fullWidth
            margin="normal"
            value={form.address}
            onChange={handleChange}
            required
          />
          <TextField
            select
            label="Select Category"
            name="category"
            fullWidth
            margin="normal"
            value={form.category}
            onChange={handleChange}
            required
          >
            <MenuItem value="agent">Agent</MenuItem>
            <MenuItem value="user">User</MenuItem>
          </TextField>
          <TextField
            label="Company Name"
            name="companyName"
            fullWidth
            margin="normal"
            value={form.companyName}
            onChange={handleChange}
            required
          />

           <Button
              variant="contained"
              fullWidth
              type="submit"
              disabled={loading}
              onClick={handleSubmit}
              sx={{
                mt: 2,
                background: "linear-gradient(90deg, #a1c97b, #8bbd5d)",
                borderRadius: "8px",
                fontWeight: "bold",
                "&:hover": {
                  background: "linear-gradient(90deg, #8bbd5d, #6fa644)",
                },
              }}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Sign Up"}
            </Button>
        </form>
      </Paper>
    </Box>
  );
}
